module.exports = __webpack_public_path__ + "img/Service-2022.d3bb3fa7.png";